<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>Informação da Marcação</h2>
                    </div>
                </div>
            </div>

            <div>
                <form [formGroup]="formularioInformacaoMarcacao" (keydown.enter)="$event.preventDefault()">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0"></mat-divider>
                    </div>

                    <div class="form-row" *ngIf="visualizarTitular">
                        <mat-form-field class="form-group col-lg-8 col-md-8 col-sm-8 col-12">
                            <mat-label>Nome do Titular</mat-label>
                            <input matInput value="Nome do Titular" class="form-control" id="nomePacienteTitular"
                                name="nomePacienteTitular" formControlName="nomePacienteTitular"
                                style="text-transform: uppercase;">
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-4 col-12">
                            <mat-label>CPF do Titular</mat-label>
                            <input matInput value="CPF do Titular" class="form-control" id="cpfTitular" trim="blur"
                                name="cpfTitular" formControlName="cpfTitular" nccCpfCnpjMask>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-4 col-12">
                            <mat-label>Data Nasc.</mat-label>
                            <input matInput [matDatepicker]="dataNascimentoDP" formControlName="dataNascimento"
                                id="dataNascimento" name="dataNascimento">
                            <mat-datepicker-toggle matSuffix [for]="dataNascimentoDP"></mat-datepicker-toggle>
                            <mat-datepicker #dataNascimentoDP></mat-datepicker>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-4 col-12">
                            <mat-label>Fone Residencial</mat-label>
                            <input matInput value="Fone Residencial" class="form-control" id="foneResidencial"
                                name="foneResidencial" phoneMask [maskInputId]="'foneResidencial'"
                                [preValue]="formularioInformacaoMarcacao.value.foneResidencial"
                                [phoneControl]="formularioInformacaoMarcacao.controls['foneResidencial']"
                                formControlName="foneResidencial">
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-4 col-12">
                            <mat-label>Núm. Celular</mat-label>
                            <input matInput value="Núm. Celular" class="form-control" id="foneCelular"
                                name="foneCelular" phoneMask [maskInputId]="'foneCelular'"
                                [preValue]="formularioInformacaoMarcacao.value.foneCelular"
                                [phoneControl]="formularioInformacaoMarcacao.controls['foneCelular']"
                                formControlName="foneCelular">
                        </mat-form-field>
                    </div>

                    <div class="form-row" *ngIf="!isMarqueExames()">
                        <mat-form-field class="form-group col-lg-12 col-md-12 col-sm-12 col-12">
                            <mat-label>Médico Atd.</mat-label>
                            <input matInput value="Médico Atd." class="form-control" id="nomeMedico" name="nomeMedico"
                                formControlName="nomeMedico" style="text-transform: uppercase;">
                        </mat-form-field>
                    </div>

                    <div class="form-row" *ngIf="isMarqueExames()">
                        <mat-form-field class="form-group col-lg-6 col-md-6 col-sm-12 col-12">
                            <mat-label>Médico Atd.</mat-label>
                            <input matInput value="Médico Atd." class="form-control" id="nomeMedico" name="nomeMedico"
                                formControlName="nomeMedico" style="text-transform: uppercase;">
                        </mat-form-field>
                        <mat-form-field class="form-group col-lg-6 col-md-6 col-sm-12 col-12">
                            <mat-label>Médico Solicitante</mat-label>
                            <input matInput value="Médico Solicitante" class="form-control" id="nomeMedicoSolicitante"
                                name="nomeMedicoSolicitante" formControlName="nomeMedicoSolicitante"
                                style="text-transform: uppercase;">
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-12 col-md-12 col-sm-12 col-12">
                            <mat-label>Funcionário Marcação</mat-label>
                            <input matInput value="Funcionário Marcação" class="form-control" id="loginUserMarcacao"
                                name="loginUserMarcacao" formControlName="loginUserMarcacao"
                                style="text-transform: uppercase;">
                        </mat-form-field>
                    </div>

                    <div class="menu-formulario">
                        <div class="menu-formulario-botoes">
                            <button type="button" mat-mini-fab color="primary" (click)="gotoList()" matTooltip="Voltar">
                                <mat-icon>west</mat-icon>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>